var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 14.9848V11.6515",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.9848V6.65149",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 14.9849V9.98486",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08337 10.8182C2.08337 7.08621 2.08337 5.22023 3.24274 4.06086C4.40212 2.90149 6.26809 2.90149 10 2.90149C13.732 2.90149 15.598 2.90149 16.7574 4.06086C17.9167 5.22023 17.9167 7.08621 17.9167 10.8182C17.9167 14.5501 17.9167 16.4161 16.7574 17.5755C15.598 18.7348 13.732 18.7348 10 18.7348C6.26809 18.7348 4.40212 18.7348 3.24274 17.5755C2.08337 16.4161 2.08337 14.5501 2.08337 10.8182Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.fe720666eb587fcb9e7785cbe53bcb5d.svg";
export { ForwardRef as ReactComponent };